import { createStore } from 'vuex'
import { getFeed } from '../external/restApi.js';

export default createStore({
    state: {
        menu: [], count: 0, kode_cabang: "", kode_divisi: "", log_data_info : [], log_data_transaksi : [], db: new Date().getFullYear(), dark_mode: false, shortcut:{}
    },
    mutations: {
        SET_MENU(state, payload) {
            state.menu = payload
        },
        SET_CABANG(state, payload) {
            state.kode_cabang = payload
        },
        SET_DIVISI(state, payload) {
            state.kode_divisi = payload
        },
        SET_LOG_INFO(state, payload) {
            state.log_data_info = payload
        },
        SET_LOG_TRANSAKSI(state, payload) {
            state.log_data_transaksi = payload
        },
        SET_CABANG_DIVISI(state, payload){
            state.kode_cabang_divisi = payload
        },
        SET_DB(state, payload) {
            state.db = payload
        },
        SET_DARK_MODE(state, payload) {
            state.dark_mode = payload
        },
        SET_SHORTCUT(state, payload){
            state.shortcut = payload
        }
    },
    actions: {
        addMenu(context, payload) {
            return getFeed("/module/users", payload.token)
                .then(result => {
                    context.commit("SET_MENU", result.data.data);
                    return result;
                })
                .catch(error => {
                    // Menu bukan data kritis. Pastikan kegagalan request saat aplikasi
                    // pertama dibuka tidak menjadi unhandled promise rejection.
                    context.commit("SET_MENU", []);
                    return { error };
                });
        },
        setCabang(context, payload) {
            context.commit('SET_CABANG', payload)
        },
        setDivisi(context, payload) {
            context.commit('SET_DIVISI', payload)
        },
        setLogInfo(context, payload) {
            context.commit('SET_LOG_INFO', payload)
        },
        setLogTransaksi(context, payload) {
            context.commit('SET_LOG_TRANSAKSI', payload)
        },
        setCabangDivisi(context, payload){
            console.log("payload", payload);
            context.commit('SET_CABANG_DIVISI', payload)
        },
        setDb(context, payload){
            console.log("payload", payload);
            context.commit('SET_DB', payload)
        },
        setDarkMode(context, payload){
            context.commit('SET_DARK_MODE', payload)
        },
        setShortcut(context, payload){
            context.commit('SET_SHORTCUT', payload)
        }
    },
    getters: {
        kode_cabang: function (state) {
            return state.kode_cabang;
        },
        kode_divisi: function (state) {
            return state.kode_divisi;
        },
        menu: function (state) {
            return state.menu;
        },
        log_data_info: function(state){
            return state.log_data_info;
        },
        log_data_transaksi: function(state){
            return state.log_data_transaksi;
        },
        kode_cabang_divisi: function(state){
            return state.kode_cabang_divisi;
        },
        db: function (state) {
            return state.db;
        },
        dark_mode: function (state){
            return state.dark_mode;
        },
        shortcut: function (state){
            return state.shortcut;
        }
    }
})
